export function translateErrorCode(errorMessage) {
  const errors = {
    "Couldn't find Commentary": 'Não foi possível encontrar o comentário',
    'translation missing: en.default_obscenity_error_message':
      'Sua publicação tem conteúdo impróprio',
    'já está em uso': 'Ops! Você já reportou abuso para este comentário!'
  };

  if (errors[errorMessage]) {
    return errors[errorMessage];
  } else {
    return errorMessage;
  }
}
